import gql from 'graphql-tag';

export const GET_TEAM_QUERY = gql`
  query GetTeam($teamId: String!) {
    getTeam(teamId: $teamId) {
      teamId
      name
      creditBalance {
        balanceId
        balance
      }
    }
  }
`;

const getTeam = () => ({
  query: GET_TEAM_QUERY,
  module: 'users',
  ignoreCache: true,
  buildVariables: (teamId) => ({ teamId }),
  isSilent: true
});

export default getTeam;